import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import { round6 } from 'utilities/math';

import {
  getTableData,
  getConfidenceInterval,
  getLimits,
  getStandardError,
  getDfValue,
  getDF
} from 'store/scenes/inferentialStatistics/selectors';

import { tableHeadersTwoSampleT } from '../shared';

const TwoSampleTConfidenceInterval = () => {
  const tableData = useSelector(state => getTableData(state));
  const confidenceInterval = useSelector(state => getConfidenceInterval(state));
  const standardError = useSelector(state => getStandardError(state));
  const { lowerLimit, upperLimit } = useSelector(state => getLimits(state));
  const dfValue = useSelector(state => getDfValue(state));
  const df = useSelector(state => getDF(state));

  return (
    <div className="content-item">
      <h3 className="mb-20">Two Sample <i>t</i> Confidence Interval Summary</h3>
      <div className="mb-5 pl-5">
        <p className="font-900 font-16 mb-5">μ1: mean of population #1</p>
        <p className="font-900 font-16">μ2: mean of population #2</p>
      </div>
      <span className="mr-5 mb-20">
        {confidenceInterval}% Confidence Interval for μ<sub>1</sub> - μ<sub>2</sub>
      </span>

      <table className="infStatMarkup-table">
        <tbody>
          <tr>
            <td>Difference of Means</td>
            <td>
              <span>{round6(dfValue)}</span>
            </td>
          </tr>
          <tr>
            <td>Lower Limit </td>
            <td>
              <span>{round6(lowerLimit)}</span>
            </td>
          </tr>
          <tr>
            <td>Upper Limit </td>
            <td>
              <span>{round6(upperLimit)}</span>
            </td>
          </tr>
          <tr>
            <td>df</td>
            <td>
              <span>{round6(df)}</span>
            </td>
          </tr>
          <tr>
            <td>Standard Error</td>
            <td>
              <span>{round6(standardError)}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Descriptive Statistics of Sample</h3>
      <Table tableHeaders={tableHeadersTwoSampleT} tableData={tableData} />
    </div>
  );
};


export default TwoSampleTConfidenceInterval;
